import React, { useEffect, useState } from 'react';
import Header from './Header';
import Header2 from './Header2';
import Footer from './Footer';
import './InfoPage.css';

const DESKTOP_BREAKPOINT = 900;

// Shared chrome (Header/Header2/hero/Footer) for every real content page
// linked from the footer - just the boilerplate every one of these pages
// needs identically; the actual content is still a distinct file per page,
// matching this codebase's own convention of real per-screen content
// rather than one mega-parameterized template.
export default function InfoPage({ eyebrow, title, subtitle, children, wide }) {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <div className="info-root">
      <Header />
      {isDesktop && <Header2 />}

      <section className="info-hero">
        {eyebrow && <span className="info-eyebrow">{eyebrow}</span>}
        <h1 className="info-title">{title}</h1>
        {subtitle && <p className="info-subtitle">{subtitle}</p>}
      </section>

      <section className={`info-content${wide ? ' info-content--wide' : ''}`}>
        {children}
      </section>

      <Footer />
    </div>
  );
}
